import { oz } from '@weft/utils';
import { CurrencySchema } from '../../../primitives';
import { BaseSystemEventMessageSchema } from '../base-system-event-message-schema';
import { SYSTEM_EVENT_MESSAGE_TYPES } from '../system-event-message-types-schema';

export const OverageSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz.literal(SYSTEM_EVENT_MESSAGE_TYPES.Overage),
  customerName: oz.string(),
  invoiceId: oz.string(),
  currency: CurrencySchema,
  overage: oz.number(),
});

export type OverageSystemEventMessage = oz.TypeOf<typeof OverageSystemEventMessageSchema>;